export type Bonus = {
  number: string
  title: string
  body: string
  accent: string
  /** Rendered cover. When empty, a code-drawn cover is shown. */
  cover?: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 60-Second Rules Reference',
    body: 'Explain any rule — two bounces, the kitchen, the serve, calling the score — in seconds, without stopping play. One printable rules card plus short one-line scripts you can say mid-rally.',
    accent: 'bg-court-teal',
    cover:
      'https://cdn.magicpatterns.com/uploads/w5YGJMUxfbqf6crHYXkCTv/DPS35_-_Bono_1_-_The_60-Second_Rules_Reference.png',
  },
  {
    number: '02',
    title: 'The Skill-Fault Fixer',
    body: 'An index by symptom — “the ball sits up”, “the drive sails long”, “the dink pops up” — with the one fix that solves it. 20+ common faults across every shot, one cue each, so reps always come with correction.',
    accent: 'bg-court-blue',
    cover:
      'https://cdn.magicpatterns.com/uploads/eUVxaZigaHMR7jbnWQkSkS/DPS35_-_Bono_2_-_The_Skill-Fault_Fixer.png',
  },
  {
    number: '03',
    title: 'The Mixed-Level Game Maker',
    body: 'A decision table plus 8–10 games, each with a handicap by level gap, so uneven groups still get fair, fun games — nobody bored, nobody overwhelmed.',
    accent: 'bg-gold',
    cover:
      'https://cdn.magicpatterns.com/uploads/uxb359t2bsWLMtH34FfSmN/DPS35_-_Bono_3_-_The_Mixed-Level_Game_Maker.png',
  },
  {
    number: '04',
    title: 'The Player Welcome One-Pager',
    body: 'A sheet to hand new players (or parents) before the first class: what to bring, what to wear, what to expect and basic court etiquette. Printable, plus an editable version.',
    accent: 'bg-[#0E7490]',
    cover:
      'https://cdn.magicpatterns.com/uploads/tqTd4jzAccWfbT4ZjUNy1w/DPS35_-_Bono_4_-_The_Player_Welcome_One-Pager.png',
  },
  {
    number: '05',
    title: 'The Low-Turnout & Rainout Rescue Card',
    body: 'Two players show up — or sixteen. It rains. You lose the court. One at-a-glance card with the most common curveballs and the instant adjustment for each, so the session still runs.',
    accent: 'bg-crimson',
    cover:
      'https://cdn.magicpatterns.com/uploads/ofNf9KW9s47EavMLNMaMi1/DPS35_-_Bono_5_-_The_Low-Turnout__Rainout_Rescue_Card.png',
  },
]
